import React, { Fragment, useState, useEffect } from 'react';
import CashonDelivery from './Cod';
import CreditCards from './CreditCard';
import DebitCards from './DebitCard';
import EMIs from './Emi';
import NetBankings from './NetBanking';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { pinagareAPIURL } from '../../../../Constant';

const PaymentDetailContain = () => {

  
  const initIsChairDetails = { isChairperson: false, isSecretary: false};

    const [nextProgressStep,setNextProgressStep] = useState('Awaits Review');
    const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
    const [percentCompleted, setPercentCompleted] = useState(10);
    const [processedSoFar, setProcessedSoFar] = useState(10);
    const history = useNavigate();
    const [isChairSecretary, setIsChairSecretary] = useState(initIsChairDetails);
    const [userDetails, setUserDetails] = useState(null);
    const [isPsApprover, setIsPsApprover] = useState(false);
    const [approverType, setApproverType] = useState('');
    const [saveBtnTxt, setSaveBtnTxt] = useState("Save");
    const [rejectBtnTxt, setRejectBtnTxt] = useState("Reject");
    const [isApprovingStageSupervisor, setIsApprovingStageSupervisor] = useState(false);
    const {scheme_application_id} =useParams();
    const [isApplicationEvaluated, setIsApplicationEvaluated] = useState(false);
    const [isApplicationOwner, setIsApplicationOwner] = useState(false);
    

    const initTimelineData = [
        {
          title: 'Application Submitted By Employee',
          subTitle: '8th March, 2024',
          time: '5 days ago',
          dis: 'The application will go through review by HR, Accounting Officer then Board Evaluation',
          color: 'primary',
        },
        
      ];
      const [timelineData, setTimelineData] = useState(initTimelineData);

      const initTodayProgressData = {
        series: [100, 10],
        options: {
          chart: {
            width: 240,
            height: 360,
            type: "radialBar",
            offsetX: -28,
          },
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  offsetY: 20,
                  color: "var(--chart-text-color)",
                  fontFamily: "Rubik, sans-serif",
                  fontWeight: 500,
                },
                value: {
                  fontSize: "22px",
                  offsetY: -16,
                  fontFamily: "Rubik, sans-serif",
                  fontWeight: 500,
                  color: "var(--chart-text-color)",
                },
                total: {
                  show: true,
                  label: "Processed!",
                  fontSize: "12px",
                  color: "var(--chart-text-color)",
                  formatter: function () {
                    return processedSoFar+"%";
                  },
                },
              },
              hollow: {
                margin: 5,
                size: "70%",
                image: null,
                imageWidth: 115,
                imageHeight: 115,
                imageClipped: false,
              },
              track: {
                background: "transparent",
              },
            },
          },
          colors: ["var(--theme-default)", "#FFA941"],
          labels: ["Submitted by Employee", "Review Progress"],
          stroke: {
            lineCap: "round",
          },
          legend: {
            show: true,
            position: "bottom",
            horizontalAlign: "center",
            offsetY: -15,
            fontSize: "14px",
            fontFamily: "Rubik, sans-serif",
            fontWeight: 500,
            labels: {
              colors: "var(--chart-text-color)",
            },
            markers: {
              width: 6,
              height: 6,
            },
          },
          responsive: [
            {
              breakpoint: 1830,
              options: {
                chart: {
                  offsetX: -40,
                },
              },
            },
            {
              breakpoint: 1750,
              options: {
                chart: {
                  offsetX: -50,
                },
              },
            },
            {
              breakpoint: 1661,
              options: {
                chart: {
                  offsetX: -10,
                },
              },
            },
            {
              breakpoint: 1530,
              options: {
                chart: {
                  offsetX: -25,
                },
              },
            },
            {
              breakpoint: 1400,
              options: {
                chart: {
                  offsetX: 10,
                },
              },
            },
            {
              breakpoint: 1300,
              options: {
                chart: {
                  offsetX: -10,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  width: 255,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  width: 245,
                },
              },
            },
            {
              breakpoint: 600,
              options: {
                chart: {
                  width: 225,
                },
              },
            },
          ],
        },
      };
    
      const [todayProgressData, setTodayProgressData] = useState(initTodayProgressData);


    useEffect(() => {
//alert(scheme_application_id);
   
        if(!isPrepopulatedDataIn){
        
          const body_t=JSON.stringify({
            
            omang:localStorage.getItem('username'),
            applicant_omang:'100511311',//localStorage.getItem('applicant_omang'),
            eng:'review_pinagare_scheme_application',
            application_id:scheme_application_id,       
            
          });
    
          pinagareFetchRequest(pinagareAPIURL,body_t,'review_pinagare_scheme_application');  
      
        }
    //alert(percentCompleted+"--"+processedSoFar);
       
    
        const thisProgressData = {
          series: [100, percentCompleted],
          options: {
            chart: {
              width: 240,
              height: 360,
              type: "radialBar",
              offsetX: -28,
            },
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    offsetY: 20,
                    color: "var(--chart-text-color)",
                    fontFamily: "Rubik, sans-serif",
                    fontWeight: 500,
                  },
                  value: {
                    fontSize: "22px",
                    offsetY: -16,
                    fontFamily: "Rubik, sans-serif",
                    fontWeight: 500,
                    color: "var(--chart-text-color)",
                  },
                  total: {
                    show: true,
                    label: "Processed!",
                    fontSize: "12px",
                    color: "var(--chart-text-color)",
                    formatter: function () {
                      return processedSoFar+"%";
                    },
                  },
                },
                hollow: {
                  margin: 5,
                  size: "70%",
                  image: null,
                  imageWidth: 115,
                  imageHeight: 115,
                  imageClipped: false,
                },
                track: {
                  background: "transparent",
                },
              },
            },
            colors: ["var(--theme-default)", "#FFA941"],
            labels: ["Submitted by Employee", "Review Progress"],
            stroke: {
              lineCap: "round",
            },
            legend: {
              show: true,
              position: "bottom",
              horizontalAlign: "center",
              offsetY: -15,
              fontSize: "14px",
              fontFamily: "Rubik, sans-serif",
              fontWeight: 500,
              labels: {
                colors: "var(--chart-text-color)",
              },
              markers: {
                width: 6,
                height: 6,
              },
            },
            responsive: [
              {
                breakpoint: 1830,
                options: {
                  chart: {
                    offsetX: -40,
                  },
                },
              },
              {
                breakpoint: 1750,
                options: {
                  chart: {
                    offsetX: -50,
                  },
                },
              },
              {
                breakpoint: 1661,
                options: {
                  chart: {
                    offsetX: -10,
                  },
                },
              },
              {
                breakpoint: 1530,
                options: {
                  chart: {
                    offsetX: -25,
                  },
                },
              },
              {
                breakpoint: 1400,
                options: {
                  chart: {
                    offsetX: 10,
                  },
                },
              },
              {
                breakpoint: 1300,
                options: {
                  chart: {
                    offsetX: -10,
                  },
                },
              },
              {
                breakpoint: 1200,
                options: {
                  chart: {
                    width: 255,
                  },
                },
              },
              {
                breakpoint: 992,
                options: {
                  chart: {
                    width: 245,
                  },
                },
              },
              {
                breakpoint: 600,
                options: {
                  chart: {
                    width: 225,
                  },
                },
              },
            ],
          },
        };
    
       // thisProgressData.options.plotOptions.radialBar.dataLabels.total.formatter=()=>{return processedSoFar+"%";};
        //thisProgressData.series[1]=percentCompleted;
       
        setTodayProgressData(thisProgressData);
    
        
    
          
      }, [processedSoFar,percentCompleted]);


    async function pinagareFetchRequest(url,body,eng) {
        try {
          await fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: body,
          })
            .then((respose) => {
              if (respose.ok) {
               
                return respose.json()
              }
              throw new Error('error')
            })
            .then((data) => {
              
             //console.log(JSON.stringify(data));
              
              if (data.status!=undefined&&data.status===true) {

                if(data.isApplicationEvaluated!=null&&data.isApplicationEvaluated!=undefined)setIsApplicationEvaluated(data.isApplicationEvaluated);
    
                
                if(data.eng==='review_pinagare_scheme_application'&&data.eng!=undefined){
    
                  //alert('success ----'+data.user.stage);
                  if(data.isApplicationOwner!==null&&data.isApplicationOwner!==undefined){
                    setIsApplicationOwner(data.isApplicationOwner);
                  }
                  else{
                    setIsApplicationOwner(false);
                  }
    
                if(data.isSupervisor!=undefined&&data.isSupervisor){


                  if(data.approverDetails!=null){
    
                  if(data.approverDetails.approver_type==='ps_approver'||data.approverDetails.approver_type==='psp_approver'){
                    setIsPsApprover(true);
                  }
                  else{
                    setIsPsApprover(false);
                  }

                  setApproverType(data.approverDetails.approver_type);
                  
                  
                  if(data.approverDetails.approver_type==="ps_approver"||data.approverDetails.approver_type==='psp_approver'){
                    setSaveBtnTxt("Application Recommended");
                    setRejectBtnTxt("Application Not Recommended");
                  }
                  else if(data.approverDetails.approver_type==="committee_approver"){
                    setSaveBtnTxt("Application Approved");
                    setRejectBtnTxt("Application Rejected");
                    
                  }
                  else{
                    setSaveBtnTxt("Application Approved");
                    setRejectBtnTxt("Application Rejected");
                  }

                }
                else{
                  setIsApprovingStageSupervisor(false);
                }

                if(data.isChairSecretary!=null){
                  setIsChairSecretary(data.isChairSecretary);
                }

                //alert(JSON.stringify(data.isChairSecretary));
                
                //alert(JSON.stringify(data.user));
                  if(data.user!=null) setUserDetails(data.user); 

                  if(data.stages_details!=null){

                  setTimelineData(data.stages_details);

                  const len=data.stages_details.length-1;
                  setNextProgressStep(data.stages_details[len].next_stage);
                  setPercentCompleted(data.stages_details[len].percentage);
                  setProcessedSoFar(data.stages_details[len].percentage);

                  }
                    
                  setIsPrepopulatedDataIn(true);
                  //toast.success("User fetch Successful...");  

                if(data.isSchemeStageSupervisor){  
                  setIsApprovingStageSupervisor(true);
                  //toast.success("User is an approving supervisor for this Stage.");
                }
                else{
    
                  //redirect
                  setIsApprovingStageSupervisor(false);
                  //toast.error("User is not an approving supervisor for this Stage.");
    
                }

              }
              else{

                  setIsApprovingStageSupervisor(false);
                  toast.error("User is not a supervisor.");
    
                  history(`${process.env.PUBLIC_URL}/dpsm/home`);
              }
    
               
              }else{
                //alert('none');
              }
             
    
                              
              } else {//alert(scheme_application_id+"---"+body);
    
                if (data.status!=null&&data.status===false) {
                  //toast.error(data.message);
                }
                else{
                 // toast.error("Data Fetch error occurred...");
                }
    
                setIsPrepopulatedDataIn(false);
                //redirect to home
                history(`${process.env.PUBLIC_URL}/dpsm/home`);
    
              }
            })
        } catch (error) {
         
          toast.error("Making Data Fetch Request failed..."); 
          setIsPrepopulatedDataIn(false);
       }
      }
    
    

    return (
        <Fragment>
            <Breadcrumbs parent="Home" title="Programmes / Review Application" mainTitle="Leadership Transformation Programme" />
            <Container fluid={true} className="credit-card">
                <Row>
                    <CreditCards isApplicationOwner={isApplicationOwner} isApplicationEvaluated={isApplicationEvaluated} isApprovingStageSupervisor={isApprovingStageSupervisor} isChairSecretary={isChairSecretary} userDetails={userDetails} isPsApprover={isPsApprover} approverType={approverType} saveBtnTxt={saveBtnTxt} rejectBtnTxt={rejectBtnTxt} />
                    <DebitCards timelineData={timelineData} />
                   
                </Row>
            </Container>
        </Fragment>
    );
};
export default PaymentDetailContain;